import { Empty } from "antd";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";

export function NothingFound() {
  const t = useDocumentsTranslations();

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={t("Nothing found")}
    />
  );
}
